import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { BusinessSupportSettingsComponent } from './business-support-settings/business-support-settings.component';
import {
  CentralInsolvencyRegisterSettingsComponent
} from './central-insolvency-register-settings/central-insolvency-register-settings.component';
import {
  ChamberOfCommerceSettingsComponent
} from './chamber-of-commerce-settings/chamber-of-commerce-settings.component';
import { CompanyInfoSettingsComponent } from './company-info-settings/company-info-settings.component';
import { CronJobSettingsComponent } from './cron-job-settings/cron-job-settings.component';
import { EmailSettingsComponent } from './email-settings/email-settings.component';
import { RdwCarDataSettingsComponent } from './rdw-cardata-settings/rdw-cardata-settings.component';
import { SettingsBaseComponent } from './settings-base/settings-base.component';
import { SettingsOverviewComponent } from './settings-overview/settings-overview.component';
import { SettingsRoutingModule } from './settings-routing.module';
import { SmsSettingsComponent } from './sms-settings/sms-settings.component';
import {
  VatnumberVerificationSettingsComponent
} from './vatnumber-verification-settings/vatnumber-verification-settings.component';
import { IbanXSSettingsComponent } from './ibanxs-settings/ibanxs-settings.component';
import { SignhostSettingsComponent } from './signhost-settings/signhost-settings.component';
import { ParbleSettingsComponent } from './parble-settings/parble-settings.component';
import { DocumentIntelligenceSettingsComponent } from './document-intelligence-settings/document-intelligence-settings.component';
import { ExactOnlineSettingsComponent } from './exact-online-settings/exact-online-settings.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    SettingsRoutingModule
  ],
  declarations: [
    SettingsBaseComponent,
    EmailSettingsComponent,
    SmsSettingsComponent,
    IbanXSSettingsComponent,
    CronJobSettingsComponent,
    CompanyInfoSettingsComponent,
    RdwCarDataSettingsComponent,
    VatnumberVerificationSettingsComponent,
    SettingsOverviewComponent,
    ChamberOfCommerceSettingsComponent,
    BusinessSupportSettingsComponent,
    CentralInsolvencyRegisterSettingsComponent,
    SignhostSettingsComponent,
    ParbleSettingsComponent,
    DocumentIntelligenceSettingsComponent,
    ExactOnlineSettingsComponent,
  ],
  entryComponents: [
    SettingsOverviewComponent
  ]
})
export class SettingsModule {
}
